import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';

import type { RootState } from '#app/reducers';
import type { AppDispatch as AppDispatchType } from '#app/hooks/actionTypes';

/** Re-exported from reducers/index.ts (inferred from combineReducers — single source of truth). */
export type { RootState };

/** Re-export typed dispatch (account, obligation actions typed; rest via AnyAction). */
export type { AppDispatchType as AppDispatch };

/**
 * Typed useSelector. Use instead of useSelector from 'react-redux'
 * so that `state` in the selector is typed as RootState.
 *
 * @example
 * const client = useAppSelector((s) => s.interfaceComponents.client);
 * const i18n = useAppSelector((s) => s.i18n);
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Typed useDispatch. Use instead of useDispatch from 'react-redux'
 * when you need to type dispatch (e.g. for thunks).
 *
 * @example
 * const dispatch = useAppDispatch();
 * dispatch(handleTitle('...'));
 */
export function useAppDispatch(): AppDispatchType {
  return useDispatch<AppDispatchType>();
}
